import { EquipmentDmgFilterType } from '@/entities/equipment';
import { TEquipmentSchema } from '@/schemas/equipment/equipment.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { mapEquipmentFilterAPI } from '@/utils/map.utils';
import { TOKEN_API_PUBLIC } from '@/utils/constant.utils';

const EQUIPMENT_URI = '/equipment';

export const createNewEquipment = async (equipment: TEquipmentSchema) => {
  return requestApi({
    url: EQUIPMENT_URI,
    method: HTTP_METHOD.POST,
    body: equipment,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingEquipment = async (query?: TEquipmentSchema) => {
  let url = `${EQUIPMENT_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.name) {
    params.append('name', query.name);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllEquipments = async () => {
  return requestApi({
    url: `${EQUIPMENT_URI}/allEquipments`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const listEquipmentsByGroupCheckpoint = async (
  groupId: string,
  checkPointId: string
) => {
  return requestApi({
    url: `${EQUIPMENT_URI}/group/${groupId}/checkpoint/${checkPointId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllEquipments = async (
  filter: EquipmentDmgFilterType,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc'
) => {
  const filterMapped = mapEquipmentFilterAPI(filter);

  let url = `${EQUIPMENT_URI}/all?${filterMapped}&page=${page}&limit=${limit}`;

  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveEquipments = async () => {
  return requestApi({
    url: `${EQUIPMENT_URI}/totalActive`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getEquipmentByName = async (name: string) => {
  return requestApi({
    url: `${EQUIPMENT_URI}/byName/${name}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getEquipmentById = async (id: string) => {
  return requestApi({
    url: `${EQUIPMENT_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const getEquipmentByClassId = async (classId: number) => {
  return requestApi({
    url: `${EQUIPMENT_URI}/byClassId/${classId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const updateEquipment = async (equipment: TEquipmentSchema) => {
  return requestApi({
    url: `${EQUIPMENT_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: equipment,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyEquipments = async (equipments: TEquipmentSchema[]) => {
  return requestApi({
    url: `${EQUIPMENT_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: equipments,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
